// import { Cell, CellButtonClickType, CellLinkClickType, ChevronRightIcon } from '@beef/ui-kit';

// import { cnBem } from '@shared/lib';
// import type { IconComponent, Or } from '@shared/types';

// const cnCell = cnBem('cell');

// const renderLogo = (Icon: Or<IconComponent, string>) => (
//   <div className={cnCell('image-wrapper', { isImage: typeof Icon === 'string' })}>
//     {typeof Icon === 'string' ?
//       <img alt="" className={cnCell('image')} src={Icon} />
//     : <Icon fill="currentColor" size={20} />}
//   </div>
// );

// TODO: как появится переделать
export var CellsViewCell = function CellsViewCell() {
  return null;

  // const {
  //   title,
  //   subTitle,
  //   icon,
  //   withRightArrow,
  //   href,
  //   onClick,
  //   className,
  //   withDivider,
  //   ...otherProps
  // } = props;

  // const cfg =
  //   href ?
  //     {
  //       linkConfig: {
  //         href,
  //         onClick: ({ event }: CellLinkClickType) => onClick?.(event),
  //       },
  //     }
  //   : {
  //       buttonConfig: {
  //         id: cnCell('cell', { title }),
  //         onClick: ({ event }: CellButtonClickType) => onClick?.(event),
  //       },
  //     };

  // return (
  //   <Cell
  //     actionIcon={withRightArrow ? <ChevronRightIcon /> : undefined}
  //     className={cnCell(null, [className])}
  //     isWithDivider={withDivider}
  //     leftSubtitle={subTitle}
  //     leftTitle={title}
  //     logo={
  //       icon ?
  //         {
  //           icon: renderLogo(icon),
  //         }
  //       : {}
  //     }
  //     {...cfg}
  //     {...otherProps}
  //   />
  // );
};